<template>
  <div class="walk">
    <div class="container">
      <div class="header">
        <h1>たくさん歩いてスタンプGET♪</h1>
        <div class="about">
          <img src="@/assets/img/walk/hatena.png" />
          <a @click="openAboutWalk">
            <span>ウォークスタンプって？</span>
          </a>
        </div>
      </div>
      <div class="steps">
        <div ref="steps" v-bind:style="{ height: stepsHeight + 'px' }">
          <template v-if="show == 0">
            <div class="title">
              <span>{{ this.goal }}歩</span>で目標達成!
            </div>
            <div class="reload" @click="reload()">
              <img src="@/assets/img/walk/reload.png" />
            </div>
            <div class="graph">
              <div
                class="wrapper"
                ref="graphWrapper"
                v-bind:style="{ height: height + 'px' }"
              >
                <img
                  src="@/assets/img/walk/progress/background.png"
                  :class="{ trans: this.progressImage != null }"
                />
                <img
                  class="color"
                  :src="this.progressImage"
                  :class="{ trans: this.progressImage != null }"
                />
                <div class="contents">
                  <div class="subtitle">今週の累計歩数</div>
                  <div class="day">{{ weekFrom }} - {{ weekTo }}</div>
                  <div class="step">
                    <span>{{
                      ((this.steps || this.steps == 0) &&
                        this.steps.toLocaleString()) ||
                      '-'
                    }}</span
                    >&nbsp;歩
                  </div>
                  <div class="today">
                    ［本日の歩数］<br />
                    {{ todayStep }}歩
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="show == 1">
            <div class="weekly">
              <div class="title">週別の歩数</div>
              <div class="reload" @click="reload()">
                <img src="@/assets/img/walk/reload.png" />
              </div>
              <WeekleBar :stepsData="weekly" unit="週" />
              <div class="step_summary">
                [週平均]
                {{
                  this.stepSummary.avg_week.toLocaleString()
                }}歩&nbsp;&nbsp;[累計歩数]{{
                  this.stepSummary.total.toLocaleString()
                }}歩
              </div>
            </div>
          </template>
          <template v-if="show == 2">
            <div class="weekly">
              <div class="title">月別の歩数</div>
              <div class="reload" @click="reload()">
                <img src="@/assets/img/walk/reload.png" />
              </div>
              <WeekleBar :stepsData="monthly" unit="月" />
              <div class="step_summary">
                [月平均]
                {{
                  this.stepSummary.avg_month.toLocaleString()
                }}歩&nbsp;&nbsp;[累計歩数]{{
                  this.stepSummary.total.toLocaleString()
                }}歩
              </div>
            </div>
          </template>
        </div>
        <div class="buttons">
          <div class="outline">
            <div v-bind:class="{ active: show == 0 }" @click="selectGraph(0)">
              今週
            </div>
            <div v-bind:class="{ active: show == 1 }" @click="selectGraph(1)">
              週グラフ
            </div>
            <div v-bind:class="{ active: show == 2 }" @click="selectGraph(2)">
              月グラフ
            </div>
          </div>
        </div>
      </div>
      <div class="caption">
        {{ this.msg1 }}<br />
        <span>{{ this.msg2 }}</span>
      </div>
      <WeekleMark :stampsInfo="stamps" />

      <div class="before">(前回の獲得日：{{ this.lastStamp }})</div>
    </div>

    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="this.needReload ? '再読み込み ' : '閉じる'"
        @submit="() => tapErrorClose()"
        @close="() => tapErrorClose()"
      />
    </template>
    <GetStamp v-if="showGetStamp" @close="this.closeGetStamp" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GetStamp from './getStamp.vue'
import WeekleBar from '@/components/Walk/WeeklyBar.vue'
import WeekleMark from '@/components/Walk/WeekMarks.vue'
import DateFormatter from '../../utils/DateFormatter.js'
import moment from 'moment'
import { FactoryTrack } from '@/constant/firebase'

import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
export default {
  name: 'WalkTop',
  components: {
    WeekleBar,
    WeekleMark,
    ErrorPopup,
    GetStamp
  },
  data: function () {
    return {
      height: 0,
      stepsHeight: null,
      show: 0,
      isError: false,
      errorMessage: '',
      errorTitle: '',
      progressImage: require(`@/assets/img/walk/progress/progress_001.png`),
      showGetStamp: false,
      switchMsg: 0,
      timerId: 0,
      needReload: false,
      retried: 0
    }
  },
  async created() {
    document.title = 'ウォークスタンプ'
    this.updateSteps()
  },
  mounted: function () {
    this.height = this.$refs.graphWrapper.clientWidth
    this.timerId = setInterval(() => {
      this.switchMsg = this.switchMsg === 0 ? 1 : 0
    }, 3000)
  },
  beforeDestroy() {
    clearInterval(this.timerId)
  },
  computed: {
    todayStep: function () {
      return this.thisWeek.length > 0
        ? this.thisWeek[this.thisWeek.length - 1].step.toLocaleString()
        : '-'
    },
    ...mapGetters({
      weekInfo: 'Walk/weekInfo',
      stamps: 'Walk/stamps',
      thisWeek: 'Walk/thisWeek',
      weekly: 'Walk/weekly',
      monthly: 'Walk/monthly',
      stepSummary: 'Walk/stepSummary',
      isGetStamp: 'Walk/isGetStamp',
      numGivingStamp: 'Walk/numGivingStamp',
      lastStampAt: 'Walk/lastStampAt'
    }),
    steps: function () {
      return this.thisWeek && this.thisWeek.length !== 0
        ? this.thisWeek.reduce((total, current) => total + current.step, 0)
        : null
    },
    goal: function () {
      return this.thisWeek && this.thisWeek.length !== 0
        ? this.weekInfo.goal_steps.toLocaleString()
        : '-'
    },
    monday: function () {
      return this.weekInfo ? moment(new Date(this.weekInfo.monday_at)) : null
    },
    weekFrom: function () {
      return this.monday ? this.monday.format('YYYY.MM.DD') : null
    },
    weekTo: function () {
      return this.monday
        ? this.monday.add(6, 'days').format('YYYY.MM.DD')
        : null
    },
    lastStamp: function () {
      return this.lastStampAt
        ? moment(new Date(this.lastStampAt)).format('YYYY.MM.DD')
        : 'ウォークスタンプ未獲得'
    },
    msg1: function () {
      return this.switchMsg === 0
        ? `4週達成すると${this.numGivingStamp}スタンプGET！`
        : 'データはこまめに反映しよう！'
    },
    msg2: function () {
      return this.switchMsg === 0
        ? `-連続でなくてもOK！自分のペースで楽しもう -`
        : '遡ってデータ反映ができるのは最大7日分となります。'
    }
  },
  watch: {
    steps: function (newSteps, oldSteps) {
      if (!this.weekInfo) {
        return null
      }

      if (newSteps == null || newSteps === '-' || newSteps === 0) {
        return null
      }
      let progress = Math.min(
        Math.floor((newSteps / this.weekInfo.goal_steps) * 100),
        100
      )
      if (progress === 0) {
        progress = 1
      }
      // setTimeout(() => {
      this.progressImage = require(`@/assets/img/walk/progress/progress_${progress
        .toString()
        .padStart('3', '0')}.png`)
    }
  },
  methods: {
    ...mapActions('Walk', ['actionFetchWalks']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionOpenAboutWalk',
      'actionReload'
    ]),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Analytics', ['trackEvent']),
    moment,
    async updateSteps() {
      const accTime = new DateFormatter().format(new Date())
      try {
        this.actionToggleLoading(true)
        window.receivedToken = (payload, steps) => {
          const json = JSON.parse(payload)
          this.fetchWalks(json.app_token, accTime, json.user_id, steps)
          window.receivedToken = null
        }
        this.actionRequestToken({
          apiType: '11',
          acc_time: accTime
        })
        setTimeout(() => {
          if (window.receivedToken) {
            if (this.retried <= 10) {
              this.retried++
              this.updateSteps()
            } else {
              this.actionToggleLoading(false)
              this.errorMessage =
                'データの読み込みに失敗しました。再読み込みをしてください'
              this.errorTitle = '通信エラー'
              this.isError = true
              this.needReload = true
              this.retried = false
              window.receivedToken = null
            }
          }
        }, 2000)
      } catch (e) {
        console.log(e)
      }
    },
    async fetchWalks(token, accTime, userId, steps) {
      try {
        this.actionToggleLoading(true)

        await this.actionFetchWalks({
          token,
          accTime,
          userId,
          steps
        })
        this.showGetStamp = this.isGetStamp
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラーが発生しました'
        this.isError = true
        this.needReload = false
        console.error(e)
      }
      this.actionToggleLoading(false)
    },

    selectGraph: function (num) {
      switch (num) {
        case 0:
          this.trackEvent(FactoryTrack.createThisWeekWalk())
          break
        case 1:
          this.trackEvent(FactoryTrack.createWeeklyWalk())
          break
        case 2:
          this.trackEvent(FactoryTrack.createMonthlyWalk())
          break
      }

      this.stepsHeight = this.$refs.steps.clientHeight
      this.show = num
    },
    reload: function () {
      this.trackEvent(FactoryTrack.createReloadWalk())
      this.actionReload()
      // this.updateSteps()
    },
    openAboutWalk: function () {
      this.trackEvent(FactoryTrack.createAboutWalk())
      this.actionOpenAboutWalk()
    },
    tapErrorClose() {
      this.isError = false
      if (this.needReload) {
        this.trackEvent(FactoryTrack.createErrorRetry())
        this.retried = 0
        this.updateSteps()
      } else {
        this.trackEvent(FactoryTrack.createErrorClose())
      }
      this.needReload = false
    },
    closeGetStamp() {
      this.showGetStamp = false
    }
  }
}
</script>

<style lang="scss" scoped>
.walk {
  display: flex;
}
.container {
  margin: 20px 0;
  padding: 0 5vw;
  width: 100%;
  color: #333333;
  .header {
    font-size: 3vw;
    h1 {
      color: #ed2a32;
      font-size: 6vw;
      font-weight: 900;
    }
    .about {
      display: inline-block;
      margin-top: 4px;
      img {
        vertical-align: middle;
        height: 18px;
      }
      a {
        display: inline-block;
        font-size: 14px;
        margin: 0 4px;
        vertical-align: middle;
        color: #333333;
        text-decoration: underline;
      }
    }
  }

  .steps {
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
    background-color: #ffffff;
    border-radius: 10px;
    margin: 10px 0;
    position: relative;
    .reload {
      position: absolute;
      top: 0;
      right: 0;
      /* padding: 10px; */
      /* background: gray; */
      /* border-radius: 0 10px 0 10px; */
      /* color: #fff; */
      img {
        width: 12vw;
      }
    }
    .title {
      font-size: 5.5vw;
      padding: 10px;
      font-weight: bold;
      span {
        color: #ed2a32;
        font-weight: bold;
      }
    }

    .graph {
      padding: 10px 15vw;

      .wrapper {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          pointer-events: none;
          width: 100%;
          opacity: 0;
          transform: scale(1.05);
          transition: all 1s ease-out;
          &.color {
            position: absolute;
          }
          &.trans {
            opacity: 1;
            transform: scale(1);
          }
        }
        .contents {
          position: absolute;
          div {
            margin: 2px 0;
          }
          .subtitle {
            color: #333333;
            font-weight: bold;
            font-size: 5vw;
            margin-top: 10px;
          }
          .day {
            font-size: 3vw;
            color: #b2b2b2;
          }
          .step {
            span {
              font-size: 10vw;
            }
            font-size: 4vw;
            color: #fd4852;
            font-weight: bold;
          }
          .today {
            font-size: 4vw;
          }
        }
      }
    }

    .buttons {
      padding: 10px 10px;
      font-weight: bold;
      font-size: 3vw;
      .outline {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #f9404a;
        border-radius: 5px;

        div {
          width: 100%;
          color: #fd4a50;
          padding: 10px 10px;

          &.active {
            color: #ffffff;
            background-color: #fd4a50;
          }

          &:not(:last-child) {
            border-right: 1px solid #fd434c;
          }
        }
      }
    }
    .weekly {
      display: flex;
      flex-direction: column;
      height: 100%;
      .bars {
        flex: 1;
      }
      .step_summary {
        color: #313031;
        font-size: 3.5vw;
        /* margin: 4px 0; */
        pointer-events: none;
        user-select: none;
      }
    }
  }
  .caption {
    font-size: 4.5vw;
    font-weight: bold;
    span {
      font-size: 3vw;
      color: #656665;
    }
  }
  .before {
    color: #82817d;
    text-align: right;
    padding: 0 10px;
    font-size: 3.5vw;
  }
}
</style>
